export const feesForOrderEndPoint = 'Order/GetFeesForOrder';
